import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Box,
  TextField,
  Button,
  Stack,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

// const API_URL = process.env.REACT_APP_CONTACT_API_URL;

const DashboardContact = () => {
  const [contacts, setContacts] = useState([]);
  const [filterDate, setFilterDate] = useState("");

  // ================= FETCH CONTACTS =================
  const fetchContacts = async (date = "") => {
    const url = date ? `${process.env.REACT_APP_CONTACT_API_URL}?date=${date}` : `${process.env.REACT_APP_CONTACT_API_URL}`;

    try {
      const res = await fetch(url);
      const data = await res.json();

      /*
        Backend may return:
        1. [] 
        2. { data: [] }
        3. { contacts: [] }
        4. { success: true, data: [] }
      */

      let contactArray = [];

      if (Array.isArray(data)) {
        contactArray = data;
      } else if (Array.isArray(data?.data)) {
        contactArray = data.data;
      } else if (Array.isArray(data?.contacts)) {
        contactArray = data.contacts;
      } else {
        contactArray = [];
      }

      setContacts(contactArray);
    } catch (error) {
      console.error("Error fetching contacts:", error);
      setContacts([]);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  // ================= DELETE CONTACT =================
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this contact?")) return;

    try {
      const res = await fetch(`${process.env.REACT_APP_CONTACT_API_URL}?action=delete`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }),
      });

      const result = await res.json();
      alert(result.message || "Deleted successfully");

      if (result.success) {
        setContacts((prev) => prev.filter((item) => item.id !== id));
      }
    } catch (error) {
      console.error("Error deleting contact:", error);
    }
  };

  return (
    <Box p={3} mt={5}>
      <Typography
        variant="h5"
        mb={3}
        fontWeight="bold"
        textAlign="center"
        sx={{ color: "white" }}
      >
        Dashboard Contact List
      </Typography>

      {/* FILTER SECTION */}
      <Stack direction="row" spacing={2} mb={3} justifyContent="center">
        <TextField
          type="date"
          label="Filter by Date"
          InputLabelProps={{ shrink: true }}
          value={filterDate}
          onChange={(e) => setFilterDate(e.target.value)}
        />

        <Button
          variant="contained"
          onClick={() => fetchContacts(filterDate)}
        >
          Filter
        </Button>

        <Button
          variant="outlined"
          onClick={() => {
            setFilterDate("");
            fetchContacts();
          }}
        >
          Reset
        </Button>
      </Stack>

      {/* TABLE */}
      <TableContainer component={Paper} elevation={4}>
        <Table>
          <TableHead sx={{ backgroundColor: "#f0f0f0" }}>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Purpose</TableCell>
              <TableCell>Created At</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {contacts.length > 0 ? (
              contacts.map((contact, index) => (
                <TableRow key={contact.id || index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{contact.name}</TableCell>
                  <TableCell>{contact.email}</TableCell>
                  <TableCell>{contact.phone}</TableCell>
                  <TableCell>{contact.purpose}</TableCell>
                  <TableCell>
                    {contact.created_at
                      ? new Date(contact.created_at).toLocaleString()
                      : "-"}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      color="error"
                      onClick={() => handleDelete(contact.id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No records found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default DashboardContact;
